import { types } from "@fraction/shared";

export interface ChecklistDocumentUrlContext {
  apiBaseUrl?: string;
  token?: string;
}

export const checklistDocumentDownloadUrl = ({
  apiBaseUrl,
  fileId,
  token,
}: ChecklistDocumentUrlContext & { fileId?: string }): string | undefined => {
  if (!apiBaseUrl || !fileId || !token) {
    return undefined;
  }
  const url = new URL(`/document/file/${encodeURIComponent(fileId)}/download`, apiBaseUrl);
  url.searchParams.set("token", token);
  return url.toString();
};

/**
 * Attach request-user-specific download URLs after checklist cache reads. JWTs
 * must never be written into the shared checklist cache.
 */
export const attachChecklistDocumentUrls = (
  items: types.ChecklistResult[],
  context: ChecklistDocumentUrlContext
): types.ChecklistResult[] =>
  items.map((item) => {
    if (!types.isDocumentChecklistItem(item)) {
      return item;
    }
    return {
      ...item,
      documentUrl: item.documentUrl || checklistDocumentDownloadUrl({ ...context, fileId: item.id }),
      documents: item.documents?.map((document) => ({
        ...document,
        documentUrl:
          document.documentUrl || checklistDocumentDownloadUrl({ ...context, fileId: document.id }),
      })),
    };
  });
